import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import PesertaSvc from "@/services/bridgingVclaim/Peserta";


interface PesertaInterface {
  "noKartu": string | null,
  "nik": string | null,
  "nama": string | null,
  "pisa": string | null,
  "sex": string | null,
  "mr": {
    "noMR": string | null,
    "noTelepon": string | null,
  },
  "tglLahir": string | null,
  "tglCetakKartu": string | null,
  "tglTAT": string | null,
  "tglTMT": string | null,
  "statusPeserta": {
    "kode": string | null,
    "keterangan": string | null,
  },
  "provUmum": {
    "kdProvider": string | null,
    "nmProvider": string | null,
  },
  "jenisPeserta": {
    "kode": string | null,
    "keterangan": string | null,
  },
  "hakKelas": {
    "kode": string | null,
    "keterangan": string | null,
  },
  "umur": {
    "umurSekarang": string | null,
    "umurSaatPelayanan": string | null,
  },
  "informasi": {
    "dinsos": string | null,
    "prolanisPRB": string | null,
    "noSKTM": string | null
  },
  "cob": {
    "noAsuransi": string | null,
    "nmAsuransi": string | null,
    "tglTMT": string | null,
    "tglTAT": string | null
  }
}

@Module({ dynamic: true, namespaced: true, store, name: "bpjs-peserta" })
class Peserta extends VuexModule {
  peserta: PesertaInterface = null;
  loading = false;
  message = null;

  @Mutation
  SET_PESERTA(data) {
    this.peserta = data;
  }

  @Mutation
  SET_MESSAGE(data) {
    this.message = data;
  }

  @Mutation
  SET_LOADING(val) {
    this.loading = val;
  }

  @Action({ rawError: true })
  async getByNoka(noka, tgl = null): Promise<void> {
    this.SET_LOADING(true);

    const dataPeserta = await PesertaSvc.getByNoka(
      noka, tgl
    ).finally(() => {
      this.SET_LOADING(false);
    });

    // const response = suketArray.data.length ? suketArray[0] : null;
    this.SET_PESERTA(dataPeserta.data?.peserta);
    this.SET_MESSAGE(dataPeserta.message);

    return dataPeserta;
  }

  @Action({ rawError: true })
  async getByNik(nik, tgl = null): Promise<void> {
    this.SET_LOADING(true);

    const dataPeserta = await PesertaSvc.getByNik(
      nik, tgl
    ).finally(() => {
      this.SET_LOADING(false);
    });

    // const response = suketArray.data.length ? suketArray[0] : null;
    this.SET_PESERTA(dataPeserta.data?.peserta);
    this.SET_MESSAGE(dataPeserta.message);

    return dataPeserta;
  }
}

export default getModule(Peserta);
